import React from "react";
import { Typography } from "@material-ui/core";
import Countdown, { formatTimeDelta, CountdownRenderProps } from 'react-countdown-now';

class OtpTimer extends React.Component{
    shouldComponentUpdate(nextProps, nextState) {
      return nextProps.timer != this.props.timer;
  } 
  examTimerComplete = () => {
      this.props.onSubmit();
  }
  
  renderer = ({ hours, minutes, seconds,}) => {
   
  const _hours = hours > 9 ? hours : '0' + hours;
  const _minutes = minutes > 9 ? minutes :  '0' + minutes;
  const _seconds = seconds > 9 ? seconds : '0' + seconds;
    // Render a countdown
    return (
      <span style={{fontWeight: 'bold', fontSize: 15, color: this.props.textStyles ? '#fff' : '#000'}}>
           {
               this.props.hours ?
  
              ` ${_hours} : ${_minutes} : ${_seconds}`
               :
               `${_minutes} : ${_seconds}`
           }
      </span>
    );
  
  }
  
    render(){
      // console.log(this.props.timer);
      return (
        <div 
      //   className={`${this.props.top} ${this.props.left}`} style={{ display: "flex", alignItems: "center", }}
        >
        
           
            <Countdown 
            date={this.props.testDetails ? Date.now() + (this.props.timer * 60 * 1000)/60  : Date.now() + this.props.timer * 60 * 1000}
            // date={this.startTimer()}
            //  formatTimeDelta={this.renderer(Date.now() + 4000000, [2])}
            onComplete={this.examTimerComplete}
            renderer={this.renderer}
            //zeroPadDays={null}
            precision={0}
            />
          </div>
      //   </div>
      );
    }
   
    
  };
  export default OtpTimer